// {
//   "mediaQuery": "min",
//   "arrows": true,
//   "pagination": true,
//   "rewind": true,
//   "autoWidth": false,
//   "gap": "2.5rem",
//   "focus": "center",
//   "type": "loop",
//   "clones": true,
//   "autoScroll": {
//     "autoStart": false,
//     "speed": 0
//   },
//   "padding": {
//     "left": "1.25rem",
//     "right": "1.25rem"
//   },
//    "breakpoints": {
//     "1024": {
//         "padding": { "left": '10%', "right": '10%' }
//      },
//     "768": {
//         "perPage": "1",
//         "focus": "center",
//         "padding": { "left": 0, "right": 0 },
//         "pagination": true
//   }
// }

// }

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".manual-blog-posts-section");
  const splideElement = section?.querySelector(".blog-grid.splide.desktop");

  if (splideElement) {
    const splide = new Splide(splideElement, {
      type: "slide",
      perPage: 3.05,
      focus: "center",
      gap: "1rem",
      padding: { left: "20%", right: "20%" },
      arrows: false,
      pagination: false,
      clones: false,
      perMove: 1,
      autoWidth: false,
      start: 1,
      breakpoints: {
        1024: {
          padding: { left: "10%", right: "10%" },
          perMove: 1,
        },
        768: {
          perPage: 1,
          focus: "center",
          padding: { left: 0, right: 0 },
          perMove: 1,
          pagination: true,
        },
      },
    });
    splide.on("mounted", () => splide.refresh());
    splide.mount();
    // setTimeout(() => {
    //   if(window.innerWidth > 768){
    //     splide.go('>'); // Swipe Left
    //   }
    //   }, 2000)
      window.addEventListener('resize', () => {
        setTimeout(() => {
          // console.log("sss");
          
          // splide.go('>'); // Swipe Left
          // splide.go('<'); // Swipe Left
        }, 2000);
      });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".manual-blog-posts-section");
  const blogGrid = section?.querySelector(".blog-grid.mobile");
  if (!blogGrid) return;

  // Convert Splide structure to Glide structure
  blogGrid.classList.remove("splide");
  blogGrid.classList.add("glide");

  const track = blogGrid.querySelector(".splide__track");
  if (track) {
    track.classList.remove("splide__track");
    track.classList.add("glide__track");
    track.setAttribute("data-glide-el", "track");

    const list = track.querySelector(".splide__list");
    if (list) {
      list.classList.remove("splide__list");
      list.classList.add("glide__slides");

      list.querySelectorAll(".splide__slide").forEach(slide => {
        slide.classList.remove("splide__slide");
        slide.classList.add("glide__slide");
      });
    }
  }

  // Add bullets (pagination dots)
  let bullets = blogGrid.querySelector('.glide__bullets');
  if (!bullets) {
    bullets = document.createElement('div');
    bullets.className = 'glide__bullets text-center mt-4';
    bullets.setAttribute('data-glide-el', 'controls[nav]');
    blogGrid.appendChild(bullets);
  }

  const slides = blogGrid.querySelectorAll('.glide__slide');
  bullets.innerHTML = '';
  slides.forEach((_, idx) => {
    const bullet = document.createElement('button');
    bullet.className = 'glide__bullet splide__pagination__page';
    bullet.setAttribute('data-glide-dir', `=${idx}`);
    bullets.appendChild(bullet);
  });

  // ✅ Initialize Glide with correct behavior
  new Glide(blogGrid, {
    type: 'slider', // no looping
    startAt: 0,
    focusAt: 0,
    gap: 20,
    perView: 3, // 👈 shows 1 full + peek of next on desktop
    rewind: false,
    autoplay: false,
    hoverpause: true,
    animationDuration: 500,
    breakpoints: {
      1024: {
        perView: 1,   // 👈 clean single slide on tablets/mobiles
        focusAt: 0
      },
      768: {
        perView: 1,
        focusAt: 0
      }
    }
  }).mount();
});
